module.exports = __webpack_public_path__ + "img/131.6053429f.jpg";